module.exports = __webpack_public_path__ + "static/ThoreauBeta1.9-DisplayRegular-542e3844f47824367a05a5406b97f44a.woff2";